import { css, Theme } from '@emotion/react'

import { border } from '@arcade/web'

import { ListOrderedTypes } from '../components'

export const getStandardNumberStyles = (theme: Theme) => css`
  ${theme.typography.listNumber}
  background-color: ${theme.arcadeColors.semantic.iconStandard};
  color: ${theme.arcadeColors.semantic.textInverse};
  min-width: ${theme.pxToRem(24)};
  height: ${theme.pxToRem(24)};
  border-radius: ${border.radius.circle};
`

export const getSubtleNumberStyles = (theme: Theme) => css`
  ${theme.typography.listNumber}
  background-color: ${theme.arcadeColors.semantic.backgroundSubtle};
  color: ${theme.arcadeColors.semantic.textStandard};
  min-width: ${theme.pxToRem(24)};
  height: ${theme.pxToRem(24)};
  border-radius: ${border.radius.circle};
  align-self: start;
`

export const getItemContentStyles = (theme: Theme, type: ListOrderedTypes = 'standard') => css`
  ${theme.typography.body}
  color: ${type === 'standard' ? theme.arcadeColors.semantic.textStandard : theme.arcadeColors.semantic.textSubtle};
  align-self: center;
`
